module.exports = __webpack_public_path__ + "static/Grupo 74-45d298ad038a46a28b17e43b1ba220cd.svg";